import { ca } from '@cian/analytics';

export function trackBuildRouteClick(objectType?: string) {
  ca('eventSite', {
    action: 'click',
    category: 'Infrastructure',
    label: 'route_button',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        PageTypeJK: 'Normal',
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
